import React, { useEffect, useState } from 'react';
import OneClickBookingScreen from './OneClickBookingScreen';
import type { Business } from '../types/business';
import type { InstantBooking } from '../services/instantBookingService';
import { UnifiedAuthService } from '../services/unifiedAuthService';

interface GuestBusinessBookingScreenProps {
  business: Business;
  serviceId?: string;
  onBack: () => void;
  onBookingComplete?: (booking: InstantBooking) => void;
}

const GuestBusinessBookingScreen: React.FC<GuestBusinessBookingScreenProps> = ({
  business,
  serviceId,
  onBack,
  onBookingComplete,
}) => {
  const [authUser, setAuthUser] = useState<any>(null);

  useEffect(() => {
    UnifiedAuthService.getCurrentUser()
      .then((u) => {
        if (u) {
          setAuthUser(u);
        }
      })
      .catch(() => {
        /* guest */
      });
  }, []);

  const userId = authUser?.id || authUser?.uid || 'guest_app';

  return (
    <OneClickBookingScreen
      guestMode
      onBack={onBack}
      userId={userId}
      user={authUser || undefined}
      onGuestAuthenticated={setAuthUser}
      onBookingComplete={onBookingComplete}
      preSelectedBusiness={business}
      preSelectedServiceId={serviceId}
    />
  );
};

export default GuestBusinessBookingScreen;
